import { useLayoutEffect } from "react";
import { useCallbackRef } from "./useCallbackRef";
// TODO: add e2e tests, jsdom doesn't support IntersectionObserver
export const useIntersectionObserver = (args) => {
    const { targetRef, callback, options: { threshold = 0.5, root, rootMargin } = {} } = args;
    const callbackRef = useCallbackRef(callback);
    useLayoutEffect(() => {
        if (targetRef.current === null || process.env.NODE_ENV === "test") {
            return;
        }
        if (root && root.current === null) {
            // eslint-disable-next-line no-console -- this means that the root element is not yet rendered or refs are not yet assigned
            console.warn("[ALCHEMY] useIntersectionObserver - root ref has been passed but is not yet rendered, defaulting to window");
        }
        const observer = new IntersectionObserver((entries) => callbackRef.current(entries), {
            threshold,
            root: root?.current,
            rootMargin
        });
        observer.observe(targetRef.current);
        return () => {
            observer.disconnect();
        };
    }, [callbackRef, threshold, targetRef, root, rootMargin]);
};
